import { render, staticRenderFns } from "./page-title.vue?vue&type=template&id=afd868b0&scoped=true"
import script from "./page-title.vue?vue&type=script&lang=ts"
export * from "./page-title.vue?vue&type=script&lang=ts"
import style0 from "./page-title.vue?vue&type=style&index=0&id=afd868b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afd868b0",
  null
  
)

export default component.exports